import React from 'react';

import {
  Footer,
  Nav,
  QrProvider,
  SkipLink,
  usePageChrome,
} from './longevity/shared';
import { PRIVACY_PATH, SUPPORT_EMAIL, content } from './longevity/content.mjs';

export default function LongevityPrivacyPage() {
  usePageChrome({
    title: content.meta.privacyTitle,
    description: content.meta.privacyDescription,
    path: PRIVACY_PATH,
  });

  const policy = content.privacyPolicy;

  return (
    <div className="lc-page">
      <QrProvider>
        <SkipLink />
        <Nav />

        <main id="lc-main" className="lc-container lc-prose">
          <h1>{content.meta.privacyTitle}</h1>
          <p className="lc-updated">Last updated {policy.updated}</p>
          <p className="lc-intro">{policy.intro}</p>

          {policy.sections.map((section) => (
            <section
              key={section.heading}
              aria-labelledby={`lc-pp-${slug(section.heading)}`}
            >
              <h2 id={`lc-pp-${slug(section.heading)}`}>{section.heading}</h2>
              {section.paragraphs.map((p) => (
                <p key={p}>{p}</p>
              ))}
              {section.contact && (
                <p>
                  <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
                </p>
              )}
            </section>
          ))}
        </main>

        <Footer />
      </QrProvider>
    </div>
  );
}

function slug(text) {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
}
